import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { InvoiceWithRelationsDto, ResponseDto } from "@mimber/schema"
import { invoicesKeys } from "../invoices.utils"

interface ResendInvoiceOptions extends Omit<
  UseMutationOptions<ResponseDto<InvoiceWithRelationsDto>, Error, void>,
  "mutationFn"
> {}

export const useResendInvoice = (
  uuid: string,
  options: ResendInvoiceOptions = {}
): UseMutationResult<ResponseDto<InvoiceWithRelationsDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useResendInvoice")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<ResponseDto<InvoiceWithRelationsDto>>(
        `invoices/${uuid}/resend`,
        {}
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: invoicesKeys.findOne(uuid) })
      options?.onSuccess?.(response, variables, onMutateResult, context)
    },
  })
}
